// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-shared-BlockWidgets-module__Input";
var _2 = "webpack-concepts-Extraction-Blocks-shared-BlockWidgets-module__Label";
var _3 = "webpack-concepts-Extraction-Blocks-shared-BlockWidgets-module__LabelText";
export { _1 as "Input", _2 as "Label", _3 as "LabelText" }
